import { makeStyles } from '@material-ui/styles';
import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import LanguageContext from '../../contexts/languageContext';
import { Age, Gender } from '../UI';
import { PropTypes } from 'prop-types';
import { getPatient } from '../../redux/Patient/PatientAction';
import { useDispatch, useSelector } from 'react-redux';
import TabBar from '../DynamicForms/TabBar/TabBar';
import arrowIcon from '../../assets/images/Icon/arrowMobile.svg';
// import useForbidden from '../../hooks/useForbidden';
import BreadCrumbs from '../BreadCrumbs';

const styles = makeStyles({
    wrapper: {
        background: '#fff',
        borderBottom: '1px solid #e8ecf2',
        direction: (props) => (props.rtl ? 'rtl' : 'ltr'),
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.06,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733'
    },
    container: {
        padding: '23px 24px 14px 24px',
        minHeight: '102px'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '15px'
    },
    // rowTitle:{
    //     display: 'flex',
    //     flexWrap:"wrap",
    //     justifyContent:'space-between',
    //     width:"100%"

    // },
    name: {
        display: 'flex',
        // alignItems: 'center',
        flexDirection: 'row-reverse',
        flexWrap: 'wrap'
        // [theme.breakpoints.down(340)]:{
        //     marginTop:"10px",
        //     alignSelf:"center",
        //     display:"block"
        // }
    },
    infoWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginRight: (props) => props.rtl && 'auto',
        marginLeft: (props) => !props.rtl && 'auto'
    },
    patientAge: {
        display: 'flex',
        alignItems: 'center',
        // flexDirection: (props) => (props.rtl ? 'row' : 'row-reverse'),
        margin: (props) => (props.rtl ? '0 8px 0 0' : '0 0 0 8px')
    },

    title: ({ isAddPatient }) => ({
        display: 'flex',
        alignItems: 'center',
        margin: isAddPatient ? '0 auto' : '',
        // margin: (props)=> props.rtl ? "0 auto 0 0" : "0 0 0 auto",
        // marginRight: (props) => !props.rtl && 'auto ',
        // marginLeft: (props) => props.rtl && 'auto',
        direction: (props) => (props.rtl ? 'ltr ' : 'rtl')
    }),
    backlink: {
        cursor: 'pointer',
        color: '#989ea3',
        width: '16px',
        height: '16px',
        transform: (props) => (props.rtl ? 'rotate(0deg)' : 'rotate(-180deg)')
    }
});

const PatientFileHeader = ({ title, isForm = false }) => {
    const { lang } = useContext(LanguageContext);
    const { pathname } = useLocation();
    const isAddPatient = pathname.split('/').filter((item) => item)[1] === 'add-patient';
    const classes = styles({ rtl: lang === 'fa', isAddPatient });
    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const patient = useSelector((state) => state.patient.patient.profile);
    // const { notAllowed } = useForbidden();

    useEffect(() => {
        // if (notAllowed) {
        //     history.replace(`/${params.clinicId}/patients`);
        // } else {
        if (!patient) {
            if (params?.id) {
                dispatch(getPatient(params?.id));
            }
        }
        // }
    }, [patient]);
    useEffect(() => {
        if (history.action === 'POP') {
            history.goBack();
        }
    }, [history.action]);

    const handleGoBack = () => {
        history.goBack();
    };

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.container}>
                    <BreadCrumbs />
                    <div className={classes.row}>
                        <div className={classes.title}>
                            <span>{title}</span>
                        </div>
                        {!isAddPatient && (
                            <div className={classes.infoWrapper}>
                                <span>
                                    {patient?.first_name} {patient?.last_name}
                                </span>
                                <div className={classes.patientAge}>
                                    {patient?.gender && (
                                        <Gender height="22" gender={patient?.gender} />
                                    )}
                                    <div>{patient?.dob && <Age dob={patient.dob} />}</div>
                                </div>
                            </div>
                        )}
                        <img
                            src={arrowIcon}
                            className={classes.backlink}
                            alt="arrow-left"
                            onClick={handleGoBack}
                        />
                    </div>
                </div>
                {isForm && <TabBar />}
            </div>
        </>
    );
};
PatientFileHeader.propTypes = {
    title: PropTypes.string,
    isForm: PropTypes.bool
};

export default PatientFileHeader;
